export default __webpack_public_path__ + "static/media/image_075_0000-1732265059355.c503214b.png";